module.exports = __webpack_public_path__ + "img/male-teenager-head.20e96c3d.svg";